import { useQuery } from '@tanstack/react-query';
import { apiFetch, useError } from './api';
import { normalizeDashboardData } from './normalizeDashboardData';

export const DASHBOARD_QUERY_KEY = ['dashboard'];

export const getDashboard = async () => {
  const response = await apiFetch(
    `${process.env.REACT_APP_API_URL}/api/admin/dashboard`,
    {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.json();
};

export const useDashboardQuery = (options = {}) => {
  const { checkError } = useError();
  const { onError, ...queryOptions } = options;

  return useQuery({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: getDashboard,
    select: normalizeDashboardData,
    ...queryOptions,
    onError: (error) => {
      checkError(error);
      onError?.(error);
    },
  });
};
